import { Flex } from 'antd';
import { SignalFilled, WifiOutlined } from '@ant-design/icons';

/** Battery has no antd equivalent; drawn in currentColor so it follows the phone theme. */
const Battery = () => (
  <svg
    width="22"
    height="11"
    viewBox="0 0 22 11"
    fill="none"
    aria-hidden="true"
    style={{ display: 'block' }}
  >
    <rect
      x="0.5"
      y="0.5"
      width="18"
      height="10"
      rx="3"
      stroke="currentColor"
      opacity="0.5"
    />
    <rect x="2" y="2" width="13" height="7" rx="1.5" fill="currentColor" />
    <path d="M20 4v3a2 2 0 0 0 0-3z" fill="currentColor" opacity="0.5" />
  </svg>
);

export const StatusBar = () => (
  <Flex justify="space-between" align="center" style={{ fontWeight: 600 }}>
    <span>9:41</span>
    <Flex align="center" gap={5} style={{ fontSize: 12 }}>
      <SignalFilled />
      <WifiOutlined />
      <Battery />
    </Flex>
  </Flex>
);
